var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew317({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 8,
    r: 5.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.36,6.31a1.5,1.5,0,0,0-.29.06A5.21,5.21,0,0,1,13.35,8a5.16,5.16,0,0,1-.25,1.53,1.19,1.19,0,0,0,.26.05,1.64,1.64,0,1,0,0-3.27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.65,8A5.16,5.16,0,0,1,2.9,6.47a1.19,1.19,0,0,0-.26,0,1.64,1.64,0,1,0,0,3.27,1.5,1.5,0,0,0,.29-.06A5.21,5.21,0,0,1,2.65,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.07,9.51V6.43h.34V7.7H5.72V6.43h.33V9.51H5.72V8.06H4.41V9.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.07,9.51,6.4,6.43h.34l.38,2c0,.21.08.42.11.63l.11-.57.48-2.08h.41L8.59,8a9.62,9.62,0,0,1,.19,1.09l.13-.67.4-2h.33L9,9.51H8.63L8.09,7.17,8,6.81c0,.13,0,.25-.08.36L7.41,9.51Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.6,6.43h.33V8.21a2.53,2.53,0,0,1-.09.74.85.85,0,0,1-.31.45,1,1,0,0,1-.59.17.93.93,0,0,1-.75-.3,1.73,1.73,0,0,1-.25-1.06V6.43h.34V8.21a2.24,2.24,0,0,0,.06.61.62.62,0,0,0,.22.28.69.69,0,0,0,.36.1.62.62,0,0,0,.51-.2,1.33,1.33,0,0,0,.17-.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew317);
export default __webpack_public_path__ + "static/media/Symbolpack_New_317.0a5bdd3578e5008c5c608c8df4662df2.svg";
export { ForwardRef as ReactComponent };